import type { User } from 'common/interfaces';
import type { MainMenuItem } from 'components/side-menu/side-menu-interfaces';
import { MainMenuTitles } from 'components/side-menu/side-menu-enums';
import { PlumpRightArrowIcon } from 'components/icons-new/plump-arrow';

export const addCustomPages = (menuItems: MainMenuItem[], user: User) => {
  return menuItems.map(menuItem => {
    const newMenuItem = { ...menuItem };

    if (newMenuItem.menuTitle === MainMenuTitles.MarketSquare) {
      user.customPages.forEach(customPage => {
        newMenuItem.subMenuItems.push({
          links: [customPage.url],
          title: customPage.title,
          roles: [],
          external: true,
          subMenuImg: <PlumpRightArrowIcon />
        });
      });
    }

    return newMenuItem;
  });
};
